import React, { CSSProperties, useEffect, useState } from 'react';

export interface IProps {
    isCollapsed?: boolean
    toggleCollapse?: (isCollapsed: boolean) => void
    style?: CSSProperties
    children: any
}

const CollapsibleCard: React.FC<IProps> = ({ isCollapsed, toggleCollapse, children, style }) => {
    const [collapsed, setCollapsed] = useState(isCollapsed)

    useEffect(() => {
        setCollapsed(isCollapsed)
    }, [isCollapsed])

    function toggleCollapsed() {
        if (toggleCollapse)
            toggleCollapse(!collapsed);

        setCollapsed(x => !x)
    }

    return <div className="card" style={style}>
        <div onClick={toggleCollapsed}><div className='pull-right' style={{margin:6, color:'#ccc'}}><i className='fa fa-chevron-down' /></div></div>
        {!collapsed && children}
    </div>
}

export default CollapsibleCard
